import { render, staticRenderFns } from "./BarOrderViewPage.vue?vue&type=template&id=56c6fe8a&scoped=true"
import script from "./BarOrderViewPage.vue?vue&type=script&lang=js"
export * from "./BarOrderViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6fe8a",
  null
  
)

export default component.exports